// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Branded 404 — brand: Midnight #071D31, Steel #3B6B94, Turquoise #6CE5E8 */

.nf-page {
  min-height: 100vh;
  background: radial-gradient(1200px 700px at 50% -10%, #10375c 0%, #071d31 55%, #050f1c 100%);
  font-family: 'Greycliff CF', 'Segoe UI', sans-serif;
  color: #fff;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nf-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.32;
  pointer-events: none;
}
.nf-glow-a { width: 420px; height: 420px; background: #6ce5e8; top: -140px; left: -120px; }
.nf-glow-b { width: 520px; height: 520px; background: #3b6b94; bottom: -200px; right: -160px; }

.nf-logo-link { display: block; padding: 28px 0 0; position: relative; z-index: 2; }
.nf-logo { height: 40px; }

.nf-content {
  position: relative;
  z-index: 2;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px 80px;
  max-width: 560px;
}

.nf-code {
  font-size: clamp(88px, 16vw, 140px);
  font-weight: 800;
  line-height: 1;
  background: linear-gradient(120deg, #6ce5e8 0%, #3b6b94 70%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -2px;
}

.nf-content h1 {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 8px 0 14px;
}

.nf-content p {
  color: #b8cddd;
  font-size: 15.5px;
  line-height: 1.6;
  margin: 0 0 34px;
}

.nf-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: center;
}

.nf-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 13px 22px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14.5px;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
.nf-btn-ghost {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #eaf4fa;
}
.nf-btn-ghost:hover { background: rgba(255, 255, 255, 0.12); color: #fff; }
.nf-btn-primary {
  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);
  color: #071d31;
  box-shadow: 0 12px 30px -10px rgba(108, 229, 232, 0.5);
}
.nf-btn-primary:hover { transform: translateY(-2px); color: #071d31; }

@media (max-width: 480px) {
  .nf-actions { flex-direction: column; width: 100%; }
  .nf-btn { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/notfound.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;EACE,iBAAiB;EACjB,4FAA4F;EAC5F,mDAAmD;EACnD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;AACA,aAAa,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AAC1F,aAAa,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;;AAE9F,gBAAgB,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,UAAU,EAAE;AACnF,WAAW,YAAY,EAAE;;AAEzB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,4DAA4D;EAC5D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,8EAA8E;AAChF;AACA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;AACA,sBAAsB,qCAAqC,EAAE,WAAW,EAAE;AAC1E;EACE,qDAAqD;EACrD,cAAc;EACd,sDAAsD;AACxD;AACA,wBAAwB,2BAA2B,EAAE,cAAc,EAAE;;AAErE;EACE,cAAc,sBAAsB,EAAE,WAAW,EAAE;EACnD,UAAU,WAAW,EAAE;AACzB","sourcesContent":["/* Branded 404 — brand: Midnight #071D31, Steel #3B6B94, Turquoise #6CE5E8 */\n\n.nf-page {\n  min-height: 100vh;\n  background: radial-gradient(1200px 700px at 50% -10%, #10375c 0%, #071d31 55%, #050f1c 100%);\n  font-family: 'Greycliff CF', 'Segoe UI', sans-serif;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.nf-glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n  opacity: 0.32;\n  pointer-events: none;\n}\n.nf-glow-a { width: 420px; height: 420px; background: #6ce5e8; top: -140px; left: -120px; }\n.nf-glow-b { width: 520px; height: 520px; background: #3b6b94; bottom: -200px; right: -160px; }\n\n.nf-logo-link { display: block; padding: 28px 0 0; position: relative; z-index: 2; }\n.nf-logo { height: 40px; }\n\n.nf-content {\n  position: relative;\n  z-index: 2;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px 24px 80px;\n  max-width: 560px;\n}\n\n.nf-code {\n  font-size: clamp(88px, 16vw, 140px);\n  font-weight: 800;\n  line-height: 1;\n  background: linear-gradient(120deg, #6ce5e8 0%, #3b6b94 70%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: -2px;\n}\n\n.nf-content h1 {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 8px 0 14px;\n}\n\n.nf-content p {\n  color: #b8cddd;\n  font-size: 15.5px;\n  line-height: 1.6;\n  margin: 0 0 34px;\n}\n\n.nf-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  justify-content: center;\n}\n\n.nf-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 13px 22px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 14.5px;\n  text-decoration: none;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n}\n.nf-btn-ghost {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #eaf4fa;\n}\n.nf-btn-ghost:hover { background: rgba(255, 255, 255, 0.12); color: #fff; }\n.nf-btn-primary {\n  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);\n  color: #071d31;\n  box-shadow: 0 12px 30px -10px rgba(108, 229, 232, 0.5);\n}\n.nf-btn-primary:hover { transform: translateY(-2px); color: #071d31; }\n\n@media (max-width: 480px) {\n  .nf-actions { flex-direction: column; width: 100%; }\n  .nf-btn { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
